/*
  Статус расчета диаграммы водопада
*/

export enum WaterfallTaskStatus {
  NotRunning = 'not running',
  Running = 'running',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Deleted = 'deleted',
}
